import { useMutation, useQuery } from "@tanstack/react-query"
import competitorsService from "services/competitors.service"

export const useGetCompetitorsModelNumbers = () => {
	return useQuery({
		queryKey: ["competitorsModelNumbers"],
		queryFn: () => competitorsService.getModelNumbers(),
		select: ({ data }) => data,
	})
}

export const useAddCompetitor = () => {
	return useMutation({
		mutationFn: (name: string) => competitorsService.addCompetitor(name),
	})
}

export const useGetCompetitors = () => {
	return useQuery({
		queryKey: ["getCompetitors"],
		queryFn: () => competitorsService.getCompetitors(),
		select: ({ data }) => data,
	})
}

export const useEditCompetitor = () => {
	return useMutation({
		mutationFn: ({ id, name }: { id: number; name: string }) => competitorsService.editCompetitor(id, name),
	})
}

export const useDeleteCompetitor = () => {
	return useMutation({
		mutationFn: (id: number) => competitorsService.deleteCompetitor(id),
	})
}

export const useEditCompetitorModelNumbers = () => {
	return useMutation({
		mutationFn: ({
			competitorId,
			modelNumbers,
			stevensId,
		}: {
			competitorId: number
			modelNumbers: string[]
			stevensId: number
		}) => competitorsService.editCompetitorModelNumbers(competitorId, modelNumbers, stevensId),
	})
}
